<template>
  <div>
    <vca-row>
      <vca-column v-if="options">
        <vca-card class="shadowed">
          <vca-field :label="$t('profile.settings.header_member')">
            <ActiveFlag v-if="options.includes('active')" />
            <br />
            <NonvotingMembership v-if="options.includes('nvm')" />
          </vca-field>
        </vca-card>

        <vca-card v-if="options.includes('volunteer_cert')" class="shadowed">
          <vca-field :label="$t('profile.certificate.header')">
            <Certificate />
          </vca-field>
        </vca-card>
      </vca-column>
      <vca-column>
        <vca-card class="shadowed">
          <Address v-if="options" />
        </vca-card>
        <vca-card class="shadowed">
          <vca-field :label="$t('profile.settings.header_roles')">
            <Roles />
          </vca-field>
          <Change />
        </vca-card>
      </vca-column>
    </vca-row>
  </div>
</template>

<script>
import ActiveFlag from "@/components/account/settings/ActiveFlag";
import Certificate from "@/components/account/settings/Certificate";
import Change from "@/components/account/settings/Change";
import Address from "@/components/account/profile/Address";
import NonvotingMembership from "@/components/account/settings/NonvotingMembership";
import Roles from "@/components/account/settings/Roles";
import { mapGetters } from "vuex";
export default {
  name: "AccountSettings",
  components: {
    Change,
    NonvotingMembership,
    ActiveFlag,
    Roles,
    Certificate,
    Address,
  },
  methods: {
    update() {
      this.$store.dispatch({ type: "user/address/update" });
    },
  },
  computed: {
    ...mapGetters({
      options: "organisations/options",
    }),
  },
};
</script>
